<template>
    <div v-if="!loading">
        <!--an email has been sent and we're waiting for confirmation-->
        <template v-if="in_progress">
            <callout callout-class="callout-warning">
                <p>{{ $t('pages.private_email.in_progress_warning', {email: pe}) }}</p>
                <p>{{ $t('pages.private_email.after24h') }}</p>
            </callout>
        </template>
        <!--we're not in the confirmation process-->
        <template v-else>
            <page-card :header="$t('pages.private_email.title')">
                <generic-notification :notifications.sync="notifications"></generic-notification>
                <!--there is an email address-->
                <template v-if="isset">
                    <div>
                        <p>{{ $t('pages.private_email.current_address') }}:</p>
                        <b-input-group>
                            <b-input-group-prepend aria-hidden="true">
                                <b-input-group-text>
                                    <b-icon-envelope aria-hidden="true"/>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input type="email" :value="pe" disabled/>
                        </b-input-group>
                    </div>
                    <b-button variant="danger"
                              class="mt-2"
                              v-if="isset"
                              id="btnRemovePe"
                              v-b-modal.modalConfirmRemovePe>
                        <b-icon-trash aria-hidden="true"/>
                        {{ $t('pages.private_email.remove') }}
                    </b-button>
                </template>
                <!--there is no email address-->
                <template v-else>
                    <b-form @submit.prevent="">
                        <callout callout-class="callout-info">
                            {{ $t('pages.private_email.not_set') }}
                        </callout>

                        <b-form-group :label="$t('pages.private_email.new_address')" label-for="frmPrivateEmailChange">
                            <b-input-group>
                                <b-input-group-prepend aria-hidden="true">
                                    <b-input-group-text>
                                        <b-icon-envelope aria-hidden="true"/>
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="email" id="frmPrivateEmailChange" :state="validEmail"
                                              placeholder="" v-model="pe" :aria-invalid="!validEmail">
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <div
                            :class="['callout', 'mt-2', consentGiven ? 'callout-success border-success' : 'callout-danger border-danger']">
                            <b-form-group class="mt-4">
                                <b-form-checkbox
                                    id="frmConsentGiven"
                                    v-model="consentGiven"
                                    name="frmConsentGiven">
                                    {{ $t('pages.consent.text') }}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>


                        <b-button variant="primary"
                                  v-if="!isset"
                                  id="btnCreatePe"
                                  :disabled="!sendable"
                                  v-b-modal.modalConfirmCreatePe>
                            <b-icon-upload aria-hidden="true"/>
                            {{ $t('pages.private_email.set') }}
                        </b-button>

                    </b-form>
                </template>
            </page-card>

            <!--modal for creating a new address-->
            <b-modal id="modalConfirmCreatePe"
                     :title="$t('common.confirmation')"
                     title-tag="h3"
                     @ok="setPe()"
                     :ok-title="$t('common.yes')"
                     :cancel-title="$t('common.cancel')">
                <p>{{ $t('pages.private_email.modal_confirm_set') }}</p>
                <p><strong>{{ pe }}</strong></p>
                <div>
                    <label for="current_password">{{ $t('common.current_password_please') }}:</label>
                    <div class="input-group mb-3">
                        <input type="password" v-model="current_password" name="current_password"
                               id="current_password"/>
                    </div>
                </div>
            </b-modal>
            <!--modal for removing the current address-->
            <b-modal id="modalConfirmRemovePe"
                     :title="$t('common.confirmation')"
                     title-tag="h3"
                     @ok="removePe()"
                     :ok-title="$t('common.yes')"
                     :cancel-title="$t('common.cancel')">
                <p>{{ $t('pages.private_email.modal_confirm_remove') }}</p>
                <p><strong>{{ pe }}</strong></p>
            </b-modal>

        </template>

    </div>
</template>


<script>
import GenericNotification from "../layout/GenericNotification";
import Callout from "../layout/Callout";
import PageCard from "../layout/PageCard";
import LoadingInjector from "../../mixins/LoadingInjector";
import BInputGroupAppendIcon from "../layout/BInputGroupAppendIcon";

export default {
    mixins: [
        LoadingInjector
    ],
    components: {
        BInputGroupAppendIcon,
        PageCard,
        Callout,
        GenericNotification,
    },
    props: {
        rzaccount: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            pe: '',
            current_password: null,
            isset: false,
            in_progress: false,
            loading: true,
            notifications: [],
            consentGiven: false,
        }
    },
    created() {
    },
    mounted() {
        console.log('Mounted PrivateEmail.');
        this.retrievePe();

        this.$Echo.private(`rz-account.${this.rzaccount}`)
            .listen('BolognaEvent', (e) => {
                console.log(e);
                if ([
                    "AttributeChangeSuccessful",
                    "AttributeChangeFailed",
                    "AttributeRemovalSuccessful",
                    "AttributeRemovalFailed"
                ].includes(e.name)) {
                    this.notifications.push(e);
                }
            });
    },
    methods: {
        setPe: function () {
            this.isset = false;
            this.axios.post(this.$Bologna.secure_url(`/v1/accounting/private-email/${this.rzaccount}`), {
                email: this.pe,
                current_password: this.current_password,
                consent: this.consentGiven,
            })
                .then(response => {
                    this.in_progress = true;
                })
                .catch(err => {
                    this.current_password = null;
                });
        },
        removePe: function () {
            this.isset = false;
            this.axios.delete(this.$Bologna.secure_url(`/v1/accounting/private-email/${this.rzaccount}`), {
                data: {}
            })
                .then(response => {
                    this.isset = false;
                    this.pe = '';
                })
                .catch(err => {

                });
        },
        retrievePe: function () {
            this.loading = true;
            this.axios.get(this.$Bologna.secure_url(`/v1/accounting/private-email/${this.rzaccount}`))
                .then(response => {
                    this.isset = response.data.data.isset;
                    this.pe = this.$purify.sanitize(response.data.data.value);
                    this.in_progress = response.data.data.in_progress;
                    this.consentGiven = response.data.data.consentGiven;
                    if (this.in_progress) {
                        this.pe = this.$purify.sanitize(response.data.data.email_to_be_confirmed);
                    }
                })
                .catch(err => {

                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    computed: {
        validEmail: function () {
            return this.pe.length
                ? this.$shared.validateEmailAddress(this.pe)
                : null;
        },
        sendable: function () {
            return this.validEmail && this.consentGiven === true;
        }
    },
    watch: {}
};
</script>
